'use client';

import React, { useState, useEffect } from 'react';
import { useAuth } from '@/lib/AuthContext';
import Image from 'next/image';
import styles from '../styles/Login.module.css';

const BANNER_IMAGES = [
  '/images/login_asset.jpg',
  '/images/login_Inventory.jpg',
  '/images/login_smarten_ERP.jpg',
  '/images/registration_Slider_Smarten_ERP.jpg',
  '/images/registration_Slider_Inventory.jpg',
  '/images/registration_Slider_asset.jpg',
];

interface LoginProps {
    onSwitchToRegister: () => void;
    onForgotPassword: () => void;
}

export function Login({ onSwitchToRegister, onForgotPassword }: LoginProps) {
    const { login } = useAuth();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const [imgIndex, setImgIndex] = useState(0);

    useEffect(() => {
        const id = setInterval(() => setImgIndex(i => (i + 1) % BANNER_IMAGES.length), 5000);
        return () => clearInterval(id);
    }, []);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);

        try {
            await login(email, password);
        } catch (err: any) {
            setError(err.message || 'Failed to login');
        } finally {
            setIsLoading(false);
        }
    };


  return (
    <div className={styles.pageWrapper}>
      <div className={styles.authCard}>
        {/* LEFT SIDE - LOGIN */}
        <div className={styles.leftPanel}>
          <div className={styles.loginHeader}>
            <Image
              src="/images/logo.svg"
              alt="Smarten"
              width={140}
              height={40}
              className={styles.logo}
            />
            <h1 className={styles.welcomeTitle}>Welcome Back</h1>
            <p className={styles.welcomeSubtitle}>Sign in to continue to Smarten Meet</p>
          </div>

          {error && <div className={styles.errorBanner}>{error}</div>}

          <form onSubmit={handleSubmit} className={styles.loginForm}>
            <div className={styles.formGroup}>
              <label className={styles.formLabel}>Email</label>
              <input
                type="email"
                className={styles.formInput}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
                disabled={isLoading}
              />
            </div>

            <div className={styles.formGroup}>
              <label className={styles.formLabel}>Password</label>
              <input
                type="password"
                className={styles.formInput}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                required
                disabled={isLoading}
              />
            </div>

            <button type="button" onClick={onForgotPassword} className={styles.forgotPasswordLink}>
              Forgot password?
            </button>

            <button type="submit" className={styles.submitButton} disabled={isLoading}>
              {isLoading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>

          <p className={styles.registerPrompt}>
            Don&apos;t have an account?{' '}
            <button type="button" onClick={onSwitchToRegister} className={styles.linkButton}>
              Sign up
            </button>
          </p>
        </div>

        {/* RIGHT SIDE - IMAGE PANEL */}
        <div className={styles.rightPanel}>
          <Image key={imgIndex} src={BANNER_IMAGES[imgIndex]} alt="Image" fill className={styles.illustration} />
        </div>
      </div>
    </div>
  );
}
